"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _router = require("@reach/router");

var _usefulState = require("useful-state");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _react2 = require("@iconify/react");

var _outlineKeyboardArrowDown = _interopRequireDefault(require("@iconify/icons-ic/outline-keyboard-arrow-down"));

var _outlineKeyboardArrowUp = _interopRequireDefault(require("@iconify/icons-ic/outline-keyboard-arrow-up"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var sharedButtonStyles = (0, _styledComponents.css)(["font-size:1rem;cursor:pointer;padding:0.75rem 1rem;text-decoration:none;transition:background-color 250ms ease-in;width:100%;&:hover,&:focus,&[aria-expanded='true']{background-color:whitesmoke;}"]);

var Button = _styledComponents["default"].button.withConfig({
  displayName: "Tree__Button",
  componentId: "sc-1nov48q-0"
})(["align-items:center;background-color:transparent;border:0;display:flex;font-size:1rem;justify-content:space-between;", ";"], sharedButtonStyles);

var Count = _styledComponents["default"].span.withConfig({
  displayName: "Tree__Count",
  componentId: "sc-1nov48q-1"
})(["background-color:whitesmoke;border-radius:500px;display:inline-block;font-size:0.733rem;font-weight:bold;height:1rem;padding:0.25rem;text-align:center;width:1rem;"]);

var TreeListItemLink = (0, _styledComponents["default"])(_router.Link).withConfig({
  displayName: "Tree__TreeListItemLink",
  componentId: "sc-1nov48q-2"
})(["display:block;", ";"], sharedButtonStyles);

var TreeList = _styledComponents["default"].ul.withConfig({
  displayName: "Tree__TreeList",
  componentId: "sc-1nov48q-3"
})(["list-style:none;margin:0;padding:0;ul{margin-bottom:1rem;li:last-of-type{border-bottom:0;}}"]);

var TreeListItem = _styledComponents["default"].li.withConfig({
  displayName: "Tree__TreeListItem",
  componentId: "sc-1nov48q-4"
})(["border-bottom:1px solid whitesmoke;display:block;width:100%;"]);

var ParentLink = function ParentLink(_ref) {
  var children = _ref.children,
      hasItems = _ref.hasItems,
      label = _ref.label,
      href = _ref.href,
      icon = _ref.icon;

  var _useToggle = (0, _usefulState.useToggle)(false),
      state = _useToggle.state,
      toggle = _useToggle.toggle;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hasItems ? /*#__PURE__*/_react["default"].createElement(Button, {
    type: "button",
    onClick: toggle,
    "aria-expanded": state
  }, /*#__PURE__*/_react["default"].createElement("span", null, icon, label), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(Count, null, hasItems), hasItems ? /*#__PURE__*/_react["default"].createElement(_react2.InlineIcon, {
    icon: state ? _outlineKeyboardArrowUp["default"] : _outlineKeyboardArrowDown["default"]
  }) : null)) : /*#__PURE__*/_react["default"].createElement(TreeListItemLink, {
    to: href
  }, icon, label), hasItems ? children(state) : null);
};

ParentLink.defaultProps = {
  icon: null
};

var generateChildLinks = function generateChildLinks(item) {
  if (!item) return null;
  var hasItems = Array.isArray(item.items) ? item.items.length : 0;
  return /*#__PURE__*/_react["default"].createElement(TreeListItem, null, /*#__PURE__*/_react["default"].createElement(ParentLink, _extends({}, item, {
    hasItems: hasItems
  }), function (open) {
    return /*#__PURE__*/_react["default"].createElement(TreeList, {
      style: {
        display: open ? 'block' : 'none'
      }
    }, item.items.concat(item.href ? [null, // renders the divider
    {
      label: 'View all',
      href: item.href
    }] : []).map(generateChildLinks));
  }));
};

var Tree = function Tree(_ref2) {
  var items = _ref2.items;
  return /*#__PURE__*/_react["default"].createElement(TreeList, null, items.map(generateChildLinks));
};

var _default = Tree;
exports["default"] = _default;